import apiV2 from '../api/v2';

interface EventImageResolveResponse {
    urls: Record<string, string>;
    expiresAt: string;
}

// The resolve endpoint caps its body at 50 ids, matching the products images resolve.
const RESOLVE_BATCH_SIZE = 50;

// Signed URLs stored in a bodyDoc go stale, so every render re-resolves by id.
// Failures return an empty map - EventBody already falls back to the stored URLs.
export async function resolveEventImageUrls(fileIds: string[]): Promise<Record<string, string>> {
    if (fileIds.length === 0) return {};

    try {
        const batches: string[][] = [];
        for (let i = 0; i < fileIds.length; i += RESOLVE_BATCH_SIZE) {
            batches.push(fileIds.slice(i, i + RESOLVE_BATCH_SIZE));
        }

        const responses = await Promise.all(
            batches.map((batch) =>
                apiV2.post<EventImageResolveResponse>('/events/images/resolve', {
                    fileIds: batch
                })
            )
        );

        return responses.reduce<Record<string, string>>(
            (urls, response) => ({ ...urls, ...(response.data?.urls ?? {}) }),
            {}
        );
    } catch {
        return {};
    }
}
